import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Check } from "lucide-react";
import { api, apiErr } from "./adminShared";
import { useAuth } from "@/context/AuthContext";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function AdminCustomers() {
  const { user } = useAuth();
  const isOwner = user?.role === "owner" || user?.role === "admin";
  const [customers, setCustomers] = useState([]);
  const load = () => api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const saveBirthday = async (c, month, day) => {
    try { await api.patch(`/admin/customers/${c.id}`, { birthday_month: month, birthday_day: day });
      toast.success("Birthday saved"); load(); } catch (e) { toast.error(apiErr(e)); }
  };
  const toggleSub = async (c) => {
    try { await api.patch(`/admin/customers/${c.id}`, { marketing_subscribed: !(c.marketing_subscribed !== false) });
      toast.success("Updated"); load(); } catch (e) { toast.error(apiErr(e)); }
  };

  const BirthdayCell = ({ c }) => {
    const [m, setM] = useState(c.birthday_month || "");
    const [d, setD] = useState(c.birthday_day || "");
    if (!isOwner || !c.id) return <span className="text-[#635B52]">{c.birthday_month ? `${MONTHS[c.birthday_month - 1]} ${c.birthday_day}` : "—"}</span>;
    return (
      <div className="flex items-center gap-1">
        <select value={m} onChange={(e) => setM(Number(e.target.value))} className="rounded border border-[#E6DEC3] text-xs px-1 py-1" data-testid={`bday-month-${c.id}`}>
          <option value="">Mo</option>{MONTHS.map((mm, i) => <option key={i} value={i + 1}>{mm}</option>)}
        </select>
        <input type="number" min="1" max="31" value={d} onChange={(e) => setD(Number(e.target.value))} placeholder="Day" className="w-14 rounded border border-[#E6DEC3] text-xs px-1 py-1" data-testid={`bday-day-${c.id}`} />
        {m && d && (m !== c.birthday_month || d !== c.birthday_day) && (
          <button onClick={() => saveBirthday(c, m, d)} className="text-[#B87333]" data-testid={`bday-save-${c.id}`}><Check size={15} /></button>
        )}
      </div>
    );
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E6DEC3] overflow-x-auto" data-testid="admin-customers">
      <table className="w-full text-sm min-w-[720px]">
        <thead className="bg-[#F5F0E8] text-[#635B52]">
          <tr>{["Name", "Email", "Phone", "Bookings", "Birthday", "Marketing", "Type"].map((h) => <th key={h} className="text-left px-4 py-3 font-medium">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-[#E6DEC3]">
          {customers.map((c, i) => (
            <tr key={i} className="hover:bg-[#FBF9F5]" data-testid={`customer-row-${i}`}>
              <td className="px-4 py-3 text-[#2C2621] font-medium">{c.name}</td>
              <td className="px-4 py-3 text-[#635B52]">{c.email}</td>
              <td className="px-4 py-3 text-[#635B52]">{c.phone || "—"}</td>
              <td className="px-4 py-3 text-[#2C2621]">{c.bookings_count}</td>
              <td className="px-4 py-3"><BirthdayCell c={c} /></td>
              <td className="px-4 py-3">
                {c.id ? (
                  <button onClick={() => isOwner && toggleSub(c)} disabled={!isOwner} className={`text-xs rounded-full px-2.5 py-1 ${c.marketing_subscribed !== false ? "bg-green-100 text-green-800" : "bg-[#E6DEC3] text-[#635B52]"}`} data-testid={`sub-toggle-${c.id}`}>
                    {c.marketing_subscribed !== false ? "Subscribed" : "Unsubscribed"}
                  </button>
                ) : <span className="text-[#635B52]">—</span>}
              </td>
              <td className="px-4 py-3 text-[#635B52]">{c.guest ? "Guest" : "Registered"}</td>
            </tr>
          ))}
          {!customers.length && <tr><td colSpan={7} className="px-4 py-10 text-center text-[#635B52]">No customers yet.</td></tr>}
        </tbody>
      </table>
      <p className="px-4 py-3 text-xs text-[#635B52] flex items-center gap-1"><Gift size={13} className="text-[#B87333]" /> Subscribed clients with a birthday get an automatic $25 code 7 days before their birthday. Only the owner can edit birthdays and marketing consent.</p>
    </div>
  );
}
